import React, { Component, useEffect, useState } from 'react';
import joi from 'joi';
import { Modal, Container, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from 'sweetalert';
import Select from 'react-select';
import MultiSelect from '../../Common/multiselect';
import DynamicTable from '../../Common/DynamicTable';
import validation from '../../utill/validation';

const ComponentOperation = ({ modelState,opStatus, handleHideModel, Operation, handleOnChange, typeList, toolList, equipmentTypeList, errors, handleChangeEquipmentType, standardType, id, handleRadioChange, getToolListForOptions, getToolListForValue, handleCloseModel, handleSubmitModelClick }) => {

  const [size, setSize] = useState('lg')
  const [rows, setRows] = useState([
    { StandardType: 'Dimension', CTQ: false } // Initial row
  ]);
  const [errors1, setErrors1] = useState({});

  useEffect(()=>{
   if(opStatus=='update'){
    setRows(Operation.Standard);
   }else{
    setRows([
      { StandardType: 'Dimension', CTQ: false } // Initial row
    ])
   }
  },[opStatus,modelState])

  // Function to handle adding a new row
  const addRow = () => {

    const errors1 = validation.validate(rows[rows.length - 1], schema);
    setErrors1(errors1 || {});
    if (errors1) return;
    setRows([...rows, { StandardType: 'Description', CTQ: false }]);
  };

  const removeRow = (index) => {

     let  data=[...rows]
     data=data.splice(index+1,1)
    setRows(data);
  };

  // Function to handle input change in a cell
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedRows = [...rows];
    updatedRows[index][name] = value;
    setRows(updatedRows);
  };

  const schema = {
    Parameter: joi.string().required(),
    Method: joi.string().required(),
    StandardType: joi.string().required(),
    Dimension: joi.number(),
    PlusTolerance: joi.number(),
    MinusTolerance: joi.number(),
    UnitOfMeasurement: joi.string(),
    UOM: joi.string(),
    CTQ: joi.boolean().required(),

  }

  return (
    <Modal size={size} show={modelState} onHide={handleHideModel}>
      <Modal.Header closeButton>
        <Modal.Title className='text-center'>Standard</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          {/* <div className="collapse" data-parent="#parent" id={`Operation${id}`}> */}
          <Col sm={12}>

            <div className="form-group text-center">
              <label>Inspection Type</label>
              {/* <select
              className="form-control form-control-sm"
              required
              onChange={handleOnChange}
              name="OperationID"
              placeholder="Enter Operation Id"

              value={Operation.OperationID}>
              <option>--Select Operation--</option>
              {operationList.map(one => {
                return <option>{one.OperationName}</option>
              })}
            </select> */}
              <MultiSelect name="InspectionType" handleOnChange={handleOnChange} masterName="InspectionType" selected={Operation['InspectionType']} all={typeList} objLevel={1} />


              {errors.InspectionType && <div className="alert small alert-danger">{errors['InspectionType']}</div>}

            </div>

            <div className="form-group text-center">
              <label>Standard Version</label>
              <input value={Operation["StandardVersion"]} className='form-control form-control-sm' type='text' name='StandardVersion' placeholder='enter version' onChange={handleOnChange} />
              {errors.StandardVersion && <div className="alert small alert-danger">{errors['StandardVersion']}</div>}
            </div>

            <div className="form-group text-center">
              <label>Effective From</label>
              <input value={Operation["EffectiveFrom"]?new Date(Operation["EffectiveFrom"]):new Date()} className='form-control form-control-sm' type='datetime-local' name='EffectiveFrom' placeholder='enter effective from' onChange={handleOnChange} />
              {errors.EffectiveFrom && <div className="alert small alert-danger">{errors['EffectiveFrom']}</div>}
            </div>

            <DynamicTable handleInputChange={handleInputChange} removeRow={removeRow} addRow={addRow} errors={errors1} rows={rows}  />


            {/* <div className="form-group">
              <label htmlFor="componentweigth">Standard Type</label>
              <br />
              <input
                type="radio"
                value={"Description"}
                checked={standardType === "Description"}
                name={`StandardType|${id}`}
                onChange={handleRadioChange}
              />
              &nbsp;<label htmlFor="yes">Description</label>
              <br />
              <input
                type="radio"

                value={"Dimension"}
                name={`StandardType|${id}`}
                checked={standardType === "Dimension"}
                onChange={handleRadioChange}
              />
              &nbsp;<label htmlFor="no">Dimension</label>
            </div>
            {standardType === "Description" ? (
              <React.Fragment>

                <div className="form-group">
                  <label htmlFor="idealcycletime">Description</label>
                  <input
                    className="form-control form-control-sm"
                    onChange={handleOnChange}
                    type="text"

                    min="0"
                    name="Description"
                    defaultValue={Operation.Description}
                  />
                  {errors.Description && <div className="alert small alert-danger">{errors['Description']}</div>}
                </div>


              </React.Fragment>
            ) : (
              <React.Fragment>

                <div className="form-group">
                  <label htmlFor="operationRejectionCost">Dimension</label>
                  <input
                    required
                    onChange={handleOnChange}
                    //disabled={cycleTimeRadioState === 1 ? false : true}
                    className="form-control"
                    type="number"
                    min="0"
                    name="Dimension"
                    defaultValue={Operation.Dimension}
                  />
                  {errors.Dimension && <div className="alert small alert-danger">{errors['Dimension']}</div>}
                </div>
                <div className="form-group">
                  <label htmlFor="operationRejectionCost">Plus Tolerance</label>
                  <input
                    required
                    onChange={handleOnChange}
                    //disabled={cycleTimeRadioState === 1 ? false : true}
                    className="form-control"
                    type="number"
                    min="0"
                    name="PlusTolerance"
                    defaultValue={Operation.PlusTolerance}
                  />
                  {errors.PlusTolerance && <div className="alert small alert-danger">{errors['PlusTolerance']}</div>}
                </div>
                <div className="form-group">
                  <label htmlFor="operationRejectionCost">Minus Tolerance</label>
                  <input
                    required
                    onChange={handleOnChange}
                    //disabled={cycleTimeRadioState === 1 ? false : true}
                    className="form-control"
                    type="number"
                    max="0"
                    name="MinusTolerance"
                    defaultValue={Operation.MinusTolerance}
                  />
                  {errors.MinusTolerance && <div className="alert small alert-danger">{errors['MinusTolerance']}</div>}
                </div>
                <div className="form-group">
                  <label htmlFor="operationRejectionCost">Minus Tolerance</label>
                  <input
                    required
                    onChange={handleOnChange}
                    //disabled={cycleTimeRadioState === 1 ? false : true}
                    className="form-control"
                    type="text"
                    max="0"
                    name="UnitOfMeasurment"
                    defaultValue={Operation.UnitOfMeasurment}
                  />
                  {errors.UnitOfMeasurment && <div className="alert small alert-danger">{errors['UnitOfMeasurment']}</div>}
                </div>
              </React.Fragment>
            )}

            <div className="form-group text-left">
              <label>CTQ : </label>
              <input style={{marginLeft:20}} type='checkbox' checked={Operation.CTQ?true:false} name='CTQ' value={Operation.CTQ?false:true}  onChange={handleOnChange} />
              {errors.CTQ && <div className="alert small alert-danger">{errors['CTQ']}</div>}
            </div> */}
          </Col>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModel} >
          Close
        </Button>
        <Button variant="primary" onClick={() => {
          const obj = { ...Operation };
          obj.Standard = rows
          handleSubmitModelClick(obj)

        }} >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ComponentOperation;
